import { inject, Injectable } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  defer,
  Observable,
  of,
  switchMap,
  tap,
} from 'rxjs';
import { PublicBoxQuestionnaireDataSourceService } from './public-box-questionnaire-data-source.service';

@Injectable({
  providedIn: 'root',
})
export class PublicBoxQuestionnaireCounterService {
  private readonly boxQuestionnaireDataSource = inject(
    PublicBoxQuestionnaireDataSourceService,
  );
  private readonly countSource$ = new BehaviorSubject<number>(0);

  private initialized = false;

  public get count$(): Observable<number> {
    return defer(() =>
      (this.initialized ? of(this.countSource$.value) : this.refresh()).pipe(
        switchMap(() => this.countSource$.asObservable()),
      ),
    );
  }

  public refresh(): Observable<number> {
    return this.boxQuestionnaireDataSource.fetchNotShownCount().pipe(
      tap((count) => {
        this.initialized = true;
        this.countSource$.next(count);
      }),
      catchError(() => {
        this.initialized = true;
        this.countSource$.next(0);

        return of(0);
      }),
    );
  }
}
